import { TOGGLE_CUSTOMER_BLOCK_MODAL } from "../customers/actionTypes";
import {
  ADD_TECHNICIAN,
  ADD_TECHNICIAN_ERROR,
  ADD_TECHNICIAN_SUCCESS,
  GET_TECHNICIAN,
  GET_TECHNICIANS,
  GET_TECHNICIANS_ERROR,
  GET_TECHNICIANS_SUCCESS,
  GET_TECHNICIAN_ERROR,
  GET_TECHNICIAN_SUCCESS,
  TOGGLE_TECHNICIAN_MODAL,
  UPDATE_TECHNICIAN,
  UPDATE_TECHNICIAN_ERROR,
  UPDATE_TECHNICIAN_SUCCESS,
  UPDATE_BLOCK_STATUS,
  UPDATE_BLOCK_STATUS_ERROR,
  UPDATE_BLOCK_STATUS_SUCCESS,
  TOGGLE_TECHNICIAN_BLOCk_MODAL,
  GET_TECHNICIAN_PURCHASES,
  GET_TECHNICIAN_PURCHASES_SUCCESS,
  GET_TECHNICIAN_PURCHASES_ERROR,
  CHANGE_TECHNICIAN_REMAINING_CALLS,
  CHANGE_TECHNICIAN_REMAINING_CALLS_SUCCESS,
  CHANGE_TECHNICIAN_REMAINING_CALLS_ERROR,
} from "./actionTypes";

const initialState = {
  // technicians
  loadingTechnicians: false,
  loadingTechniciansSuccess: false,
  loadingTechniciansError: null,
  technicians: {},
  // add technician
  technician: {},
  addTechnicianLoading: false,
  addTechnicianError: null,
  addTechnicianSuccess: false,
  // get technician
  getTechnicianLoading: false,
  getTechnicianError: null,
  getTechnicianSuccess: null,
  // update technician
  updateTechnicianLoading: false,
  updateTechnicianError: null,
  updateTechnicianSuccess: null,
  // block technician update
  updatingBlockStatus: false,
  updateBlockStatusSuccess: false,
  updateBlockStatusError: null,
  // purchases
  technicianPurchases: {},
  technicianPurchasesLoading: false,
  technicianPurchasesError: null,
  technicianPurchasesSuccess: false,
  // change technician remaining calls
  changeTechnicianRemainingCallsLoading: false,
  changeTechnicianRemainingCallsError: null,
  changeTechnicianRemainingCallsSuccess: null,
};

const technicians = (state = initialState, action) => {
  switch (action.type) {
    case GET_TECHNICIANS:
      state = {
        ...state,
        addTechnicianSuccess: false,
        updateTechnicianSuccess: false,
        loadingTechnicians: true,
        loadingTechniciansSuccess: false,
        loadingTechniciansError: null,
        technicians: [],
        technician: {},
      };
      break;
    case GET_TECHNICIANS_SUCCESS:
      state = {
        ...state,
        loadingTechnicians: false,
        loadingTechniciansSuccess: true,
        loadingTechniciansError: null,
        technicians: action.payload,
      };
      break;
    case GET_TECHNICIANS_ERROR:
      state = {
        ...state,
        loadingTechniciansError: action.payload,
        loadingTechnicians: false,
        loadingTechniciansSuccess: false,
        technicians: [],
      };
      break;
    case ADD_TECHNICIAN:
      state = {
        ...state,
        addTechnicianLoading: true,
        addTechnicianError: null,
        addTechnicianSuccess: false,
      };
      break;
    case ADD_TECHNICIAN_SUCCESS:
      state = {
        ...state,
        addTechnicianLoading: false,
        addTechnicianError: null,
        addTechnicianSuccess: true,
        technician: {},
      };
      break;
    case ADD_TECHNICIAN_ERROR:
      state = {
        ...state,
        addTechnicianLoading: false,
        addTechnicianError: action.payload,
        addTechnicianSuccess: false,
      };
      break;
    case GET_TECHNICIAN:
      state = {
        ...state,
        technician: {},
        getTechnicianLoading: true,
        getTechnicianSuccess: false,
        getTechnicianError: null,
      };
      break;
    case GET_TECHNICIAN_SUCCESS:
      state = {
        ...state,
        getTechnicianError: null,
        getTechnicianSuccess: true,
        getTechnicianLoading: false,
        technician: action.payload,
      };
      break;
    case GET_TECHNICIAN_ERROR:
      state = {
        ...state,
        getTechnicianError: action.payload,
        getTechnicianLoading: false,
        getTechnicianSuccess: false,
      };
      break;
    case UPDATE_TECHNICIAN:
      state = {
        ...state,
        updateTechnicianLoading: true,
        updateTechnicianError: null,
        updateTechnicianSuccess: false,
      };
      break;
    case UPDATE_TECHNICIAN_SUCCESS:
      state = {
        ...state,
        updateTechnicianLoading: false,
        updateTechnicianError: null,
        updateTechnicianSuccess: true,
      };
      break;
    case UPDATE_TECHNICIAN_ERROR:
      state = {
        ...state,
        updateTechnicianLoading: false,
        updateTechnicianError: action.payload,
        updateTechnicianSuccess: true,
        technician: {},
      };
      break;
    case TOGGLE_TECHNICIAN_MODAL:
      state = {
        ...state,
        technician: {},
      };
      break;
    case UPDATE_BLOCK_STATUS:
      state = {
        ...state,
        updatingBlockStatus: true,
        updateBlockStatusError: null,
        updateBlockStatusSuccess: false,
      };
      break;
    case UPDATE_BLOCK_STATUS_SUCCESS:
      state = {
        ...state,
        updatingBlockStatus: false,
        updateBlockStatusError: null,
        updateBlockStatusSuccess: true,
      };
      break;
    case UPDATE_BLOCK_STATUS_ERROR:
      state = {
        ...state,
        updatingBlockStatus: false,
        updateBlockStatusError: action.payload,
        updateBlockStatusSuccess: false,
        blockStatus: {},
      };
      break;
    case TOGGLE_TECHNICIAN_BLOCk_MODAL:
    case TOGGLE_CUSTOMER_BLOCK_MODAL:
      state = {
        ...state,
        blockStatus: {},
      };
      break;
    case GET_TECHNICIAN_PURCHASES:
      state = {
        ...state,
        technicianPurchasesLoading: true,
        technicianPurchasesSuccess: false,
        technicianPurchasesError: null,
        technicianPurchases: [],
      };
      break;
    case GET_TECHNICIAN_PURCHASES_SUCCESS:
      state = {
        ...state,
        technicianPurchasesLoading: false,
        technicianPurchasesSuccess: true,
        technicianPurchasesError: null,
        technicianPurchases: action.payload,
      };
      break;
    case GET_TECHNICIAN_PURCHASES_ERROR:
      state = {
        ...state,
        technicianPurchasesLoading: false,
        technicianPurchasesSuccess: false,
        technicianPurchasesError: action.payload,
        technicianPurchases: [],
      };
      break;
    case CHANGE_TECHNICIAN_REMAINING_CALLS:
      state = {
        ...state,
        changeTechnicianRemainingCallsLoading: true,
        changeTechnicianRemainingCallsSuccess: false,
        changeTechnicianRemainingCallsError: null,
      };
      break;
    case CHANGE_TECHNICIAN_REMAINING_CALLS_SUCCESS:
      {
        const { id, value } = action.payload;
        let newState = {
          ...state,
          technicianPurchases: state.technicianPurchases.map((item) =>
            item.id === id ? { ...item, remainingCalls: value } : item
          ),
          changeTechnicianRemainingCallsLoading: false,
          changeTechnicianRemainingCallsSuccess: true,
          changeTechnicianRemainingCallsError: null,
        };
        state = newState;
      }
      break;
    case CHANGE_TECHNICIAN_REMAINING_CALLS_ERROR:
      state = {
        ...state,
        changeTechnicianRemainingCallsLoading: false,
        changeTechnicianRemainingCallsSuccess: false,
        changeTechnicianRemainingCallsError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default technicians;
